"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = void 0 && (void 0).__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var spaui_utils_1 = require("@tencent/spaui-utils");
var info_1 = __importDefault(require("./info"));
var spaui_1 = require("@tencent/spaui");
var odc_frame_1 = __importDefault(require("@tencent/odc-frame"));
var Toolbar = function Toolbar(props) {
  var left = props.left,
    right = props.right,
    leftClassName = props.leftClassName,
    rightClassName = props.rightClassName,
    leftProps = props.leftProps,
    rightProps = props.rightProps,
    _a = props.clear,
    clear = _a === void 0 ? false : _a,
    onClear = props.onClear,
    restProps = __rest(props, ["left", "right", "leftClassName", "rightClassName", "leftProps", "rightProps", "clear", "onClear"]);
  var _b = __read((0, react_1.useState)(true), 2),
    visible = _b[0],
    setVisible = _b[1];
  return visible ? react_1["default"].createElement(odc_frame_1["default"], __assign({}, restProps, (0, spaui_utils_1.globalProps)(props, {
    className: (0, classnames_1["default"])('odc-toolbar', {
      'has-right': right,
      'has-clear': clear,
      'no-left': !left
    }),
    supportAllEvents: true
  }, Toolbar)), react_1["default"].createElement(odc_frame_1["default"], __assign({
    className: (0, classnames_1["default"])('odc-toolbar-left', leftClassName)
  }, leftProps), left), right ? react_1["default"].createElement(odc_frame_1["default"], __assign({
    className: (0, classnames_1["default"])('odc-toolbar-right', rightClassName)
  }, rightProps), right) : null, clear ? react_1["default"].createElement(spaui_1.Button, {
    baseClass: "odc-toolbar-clear",
    onClick: function onClick(e) {
      if (onClear) {
        onClear(e);
      } else {
        setVisible(false);
      }
    }
  }, react_1["default"].createElement(spaui_1.Icon, {
    name: "close-normal-outlined",
    className: "odc-toolbar-clear-svg"
  })) : null) : null;
};
(0, spaui_utils_1.setComponentMark)(Toolbar, info_1["default"]);
exports["default"] = react_1["default"].memo(Toolbar);